import { render, staticRenderFns } from "./ProductsInRecycle.vue?vue&type=template&id=2834d002&scoped=true"
import script from "./ProductsInRecycle.vue?vue&type=script&lang=js"
export * from "./ProductsInRecycle.vue?vue&type=script&lang=js"
import style0 from "./ProductsInRecycle.vue?vue&type=style&index=0&id=2834d002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834d002",
  null
  
)

export default component.exports